import { Select, DatePicker, Input, Button, List, Spin, Table } from "antd";
import React, { useState, useEffect } from "react";
import "../../reporting/Reporting.scss";
import previewList from "../../../../Assets/svg/table-action-preview.svg";
import downloadList from "../../../../Assets/svg/downloadList.svg";
import { httpService } from "../../../../services/httpService.service";
import Preview from "../../../pages/planning/VisitBoard/TableView/modals/Preview";
import SearchIcon from "./../../../../Assets/svg/searchIcon.svg";
import { exportToExcel } from "../../../components/ExportToExcel/exportToExcel";
import MessagePopUp from "../../../components/Messages/MessagePopUp";
import ExportButton from "../../../../Assets/svg/exportButton.svg";

import {
  formatDate,
  formatDateAndTime,
} from "../../../../services/helpFunctions/formatDateAndTime";
import ExportTable from "../../../components/ExportExcel/exportTable";
import ExportSelectedTable from "../../../components/ExportExcel/ExportSelectedExcel/exportSelectedTable";
import FacilityTag from "../../../components/FacilityTag/FacilityTag";
import { COMPLETED_DEFAULT_COLUMNS } from "../../../components/SiteVisitColumns/siteVisitColumnOrder";
import { useSiteVisitColumns } from "../../../components/SiteVisitColumns/useSiteVisitColumns";

function ReportingList() {
  const [loading, setLoading] = useState(false);
  const [pagination, setPagination] = useState({
    pageSize: 10,
    pageNumber: 1,
    total: 0,
  });
  const [siteVisitCards, setSiteVisitCards] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [showPreviewModal, setShowPreviewModal] = useState(false);
  const [selectedSiteVisit, setSelectedSiteVisit] = useState(null);
  const [debouncedQuery, setDebouncedQuery] = useState(searchQuery);
  const [isLargeScreen, setIsLargeScreen] = useState(window.innerWidth > 576);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [selectedSiteVisits, setSelectedSiteVisits] = useState([]);
  const [selectedSiteVisitIds, setSelectedSiteVisitIds] = useState([]);
  const [isSelectedModalVisible, setIsSelectedModalVisible] = useState(false);
  const [message, setMessage] = useState({
    trigger: false,
    type: "",
    icon: "",
    title: "",
    text: "",
  });

  useEffect(() => {
    const handleResize = () => {
      setIsLargeScreen(window.innerWidth > 576);
    };
    window.addEventListener("resize", handleResize);
    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const handleSearch = (e) => {
    const search = e.target.value;
    setSearchQuery(search);
    setPagination((prevPagination) => ({
      ...prevPagination,
      pageNumber: 1,
    }));
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedQuery(searchQuery);
    }, 500);

    return () => clearTimeout(timer);
  }, [searchQuery]);

  const { Option } = Select;

  useEffect(() => {
    const projectId = localStorage.getItem("currentProjectID");

    const params = {
      ProjectId: projectId,
      // SiteVisitStatus: "5",
      //  SiteVisitStatus: "6",
      ApprovalStatus: "2",
      IncludeOnlyWithTracking: "true",
      // IgnorePagination: "true",
      Search: "",
      total: pagination.totalItelmCount,
      pageSize: pagination.pageSize,
      pageNumber: pagination.pageNumber,
    };
    const filteredParams = Object.fromEntries(
      Object.entries(params).filter(
        ([_, value]) => value !== undefined && value !== null,
      ),
    );

    const queryString = new URLSearchParams(filteredParams).toString();

    const apiUrl = `/api/Site/getAllSiteVisits?${queryString}`;
    setLoading(true);
    httpService
      .get(
        apiUrl,
        (res) => {
          setSiteVisitCards(res.data);
          setPagination({
            pageSize: res.metaData.pageSize,
            pageNumber: res.metaData.pageNumber,
            total: res.metaData.totalItemCount,
          });
        },
        (error) => {
          // console.log(error);
        },
      )
      .finally(() => {
        setLoading(false);
      });
  }, [pagination.pageNumber, pagination.pageSize, debouncedQuery]);

  const handleTogglePreviewModal = (record) => {
    const siteVisitCardId = record?.key;
    setSelectedSiteVisit(siteVisitCardId);
    setShowPreviewModal(!showPreviewModal);
  };

  const handleToggleExportModal = (record) => {
    const siteVisitCardData = siteVisitCards.find(
      (card) => card.id === record.key,
    );
    if (siteVisitCardData) {
      const fileName = siteVisitCardData.identifier || "SiteVisit";
      exportToExcel([formatData(siteVisitCardData)], fileName);
    }
  };

  const statusMappingSiteVisitStatus = (status) => {
    // Ensure status is a number
    const numericStatus = Number(status);
    switch (numericStatus) {
      case 1:
        return {
          text: "No status",
          className: "noStatus",
          fill: "rgba(172, 12, 12, 0.777)",
        };
      case 2:
        return {
          text: "Data collection in progress",
          className: "progress",
          fill: "#3B81FE",
        };
      case 3:
        return {
          text: "Selected for monitoring",
          className: "monitoring",
          fill: "#FC9403",
        };
      case 4:
        return { text: "Review", className: "review", fill: "#9670B8" };
      case 5:
        return { text: "Delivered", className: "delivered", fill: "#045B46" };
      case 6:
        return { text: "Debrief", className: "debrief", fill: "#0F7507" };
      default:
        return {
          text: "No status",
          className: "noStatus",
          fill: "rgba(172, 12, 12, 0.777)",
        };
    }
  };

  const columns = [
    {
      title: <span className="styledTitle">Site Visit Identifier</span>,
      sorter: (a, b) =>
        a.siteVisitIdentifier.localeCompare(b.siteVisitIdentifier),
      dataIndex: "siteVisitIdentifier",
      key: "siteVisitIdentifier",
      render: (text) => <span className="styledDataIndex3">{text}</span>,
    },
    {
      title: <span className="styledTitle">Site Visit Name</span>,
      sorter: (a, b) => a.siteVisitName.localeCompare(b.siteVisitName),
      dataIndex: "siteVisitName",
      key: "siteVisitName",
      render: (text) => <span className="styledDataIndex3">{text}</span>,
    },
    {
      title: <span className="styledTitle">Site Visit Status</span>,
      dataIndex: "siteVisitStatus",
      key: "siteVisitStatus",
      width: 250,
      sorter: (a, b) => {
        const statusA = a?.siteVisitStatus || "";
        const statusB = b?.siteVisitStatus || "";
        return String(statusA).localeCompare(String(statusB));
      },
      render: (text, record) => {
        const status = record?.siteVisitStatus;
        const {
          text: statusText,
          className,
          fill,
        } = statusMappingSiteVisitStatus(status);
        return (
          <div className={className}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="8px"
              height="8px"
              viewBox="0 0 9 9"
            >
              <circle cx="4.5" cy="4.27344" r="4" fill={fill} />
            </svg>
            <span>{statusText}</span>
          </div>
        );
      },
    },
    {
      title: <span className="styledTitle">Facility</span>,
      dataIndex: "facility",
      key: "facility",
      width: 250,
      sorter: (a, b) =>
        (a.facility?.name || "").localeCompare(b.facility?.name || ""),
      render: (facility) => <FacilityTag facility={facility} />,
    },
    {
      title: <span className="styledTitle">Actual Dates of Visit</span>,
      sorter: (a, b) => {
        const aDate = a.actualDateOfVisit?.[0] || "";
        const bDate = b.actualDateOfVisit?.[0] || "";
        return aDate.localeCompare(bDate);
      },
      dataIndex: "actualDateOfVisit",
      key: "actualDateOfVisit",
      render: (data) =>
        data?.length ? (
          data?.map((date) => (
            <span
              className="styledDataIndex3"
              style={{ display: "block" }}
              key={date.id}
            >
              {date}
            </span>
          ))
        ) : (
          <span className="styledDataIndex3">
            No actual date of visit available
          </span>
        ),
    },
    {
      title: <span className="styledTitle">IP</span>,
      sorter: (a, b) => a.ip.localeCompare(b.ip),
      dataIndex: "ip",
      key: "ip",
      render: (text) => <span className="styledDataIndex3">{text}</span>,
    },

    {
      title: <span className="styledTitle">Location</span>,
      sorter: (a, b) =>
        a.locationDetails?.country.localeCompare(b.locationDetails?.country),
      key: "location",
      dataIndex: "location",
      render: (text) => <span className="styledDataIndex3">{text}</span>,
    },
    {
      title: <span className="styledTitle">Governate/State</span>,
      dataIndex: "state",
      key: "state",
      render: (text) => <span className="styledDataIndex3">{text}</span>,
    },
    {
      title: <span className="styledTitle">Cluster</span>,
      sorter: (a, b) => a.cluster.localeCompare(b.cluster),
      dataIndex: "cluster",
      key: "cluster",
      render: (text) => <span className="styledDataIndex3">{text}</span>,
    },
    {
      title: <span className="styledTitle">Virtual</span>,
      sorter: (a, b) => a.virtual.localeCompare(b.virtual),
      dataIndex: "virtual",
      key: "virtual",
      render: (text) => <span className="styledDataIndex3">{text}</span>,
    },
    {
      title: <span className="styledTitle">Resources</span>,
      sorter: (a, b) =>
        a.resources?.join("").localeCompare(b.resources?.join("")),
      dataIndex: "resources",
      key: "resources",
      render: (resources) => {
        return (
          <div className="resourcesColumn">
            {resources?.map((text, index) => (
              <span key={index}>{text}</span>
            ))}
          </div>
        );
      },
    },
    {
      title: <span className="styledTitle"></span>,
      key: "action",
      fixed: isLargeScreen && siteVisitCards.length > 0 ? "right" : undefined,

      render: (text, record) => (
        <div className="actionDiv">
          {/* {tracked && ( */}
          {/* )} */}
          {/* {isAuthorized([
            RolesEnum.SystemAdmin,
            RolesEnum.ProjectManager,
            RolesEnum.FieldCoordinator,
            RolesEnum.FieldLogistics,
            RolesEnum.FieldTeamLeader,
          ]) && ( */}
          {/* <img
            src={downloadList}
            onClick={() => handleToggleExportModal(record)}
            style={{ cursor: "pointer" }}
          /> */}
          <img
            src={previewList}
            onClick={() => handleTogglePreviewModal(record)}
            style={{ cursor: "pointer" }}
          ></img>
        </div>
      ),
    },
  ];

  const formatData = (siteVisitCard) => {
    return {
      key: siteVisitCard?.id,
      siteVisitIdentifier: siteVisitCard?.identifier,
      siteVisitName: siteVisitCard?.name,
      actualDateOfVisit: siteVisitCard?.tracking?.siteTrackingVisitDates.map(
        (date) => formatDate(date?.visitDate),
      ),
      ip: siteVisitCard?.ipPlan?.implementingPartner?.name,
      location: siteVisitCard?.locationDetails?.country,
      state:
        siteVisitCard?.locationDetails?.state || "This country has no states.",
      cluster: siteVisitCard?.cluster?.name,
      siteVisitStatus: siteVisitCard?.siteVisitStatus,
      virtual: siteVisitCard?.isVirtual ? "Yes" : "No",
      resources: siteVisitCard?.siteVisitFiles
        .filter(
          (item) =>
            item.fileCategory === 1 ||
            item.fileCategory === 3 ||
            item.fileCategory === 4,
        )
        ?.slice(-2)
        .map((file) => file?.fileName),

      reportingYear: siteVisitCard?.tracking?.reportingYear,
      reportingMonth: siteVisitCard?.tracking?.reportingMonth,
      trainingDate: siteVisitCard?.tracking?.trainingDate,
      trainingScoreInfo: siteVisitCard?.tracking?.trainingScoreInfo,
      dateOfReport: siteVisitCard?.tracking?.dateOfReport,
      dateOfDebrief: siteVisitCard?.tracking?.dateOfDebrief,
      percentageOfDataCollectionCompleted:
        siteVisitCard?.tracking?.percentageOfDataCollectionCompleted,
      fieldTeamReportingStatus:
        siteVisitCard?.tracking?.fieldTeamReportingStatus,
      trainingIsCompleted: siteVisitCard?.tracking?.trainingIsCompleted,
    };
  };

  const formattedData = siteVisitCards?.map(formatData);

  const {
    columns: visibleColumns,
    columnsBar,
    components: tableComponents,
  } = useSiteVisitColumns({
    tableId: "completedReportingList",
    columns: columns,
    defaultKeys: COMPLETED_DEFAULT_COLUMNS,
  });

  const onPageChange = (page, pageSize) => {
    setPagination({ ...pagination, pageNumber: page, pageSize: pageSize });
  };

  const handleModalCancel = () => {
    setIsModalVisible(false);
    setSelectedSiteVisits([]);
  };

  const handleSelectedModalCancel = () => {
    setIsSelectedModalVisible(false);
  };

  const handleExportClick = () => {
    setIsModalVisible(true);
  };

  const rowSelection = {
    onChange: (selectedRowKeys, selectedRows) => {
      setSelectedSiteVisitIds(selectedRowKeys);
    },
    getCheckboxProps: (record) => ({
      disabled: false, // Set to true if you want to disable specific rows
    }),
  };

  // Handle export button click
  const handleSelectedExportClick = () => {
    if (selectedSiteVisitIds.length === 0) {
      setMessage({
        trigger: true,
        type: "warning",
        icon: "warning",
        title: "No Rows Selected",
        text: "Please select at least one row to export.",
      });
      return;
    }
    setIsSelectedModalVisible(true);
  };
  return (
    <>
      <div className="reportingListDiv">
        <div className="tableHeader">
          <span className="tableViewHeaderText">Completed Site Visits</span>

          <MessagePopUp
            trigger={message.trigger}
            type={message.type}
            icon={message.icon}
            messageTitle={message.title}
            messageText={message.text}
          />
          <div className="tableViewHeaderButtons">
            <Button
              className="addButtonTPM"
              onClick={handleSelectedExportClick}
            >
              <img src={ExportButton} alt="" />
              Export Selected Site Visits
            </Button>

            <Button
              className="exportButtonTPM addButtonTPM"
              onClick={handleExportClick}
            >
              <img src={ExportButton} alt="" />
              Export All Site Visits in this Project
            </Button>
          </div>
        </div>

        <div className="filtersWrapper">
          <div className="containerFilters">
            <Input
              onChange={handleSearch}
              placeholder="Search... "
              suffix={<img src={SearchIcon} alt="Search" />}
            />
          </div>
        </div>
        <div
          className="w-100 my-3 d-flex justify-content-start gap-2"
          style={{
            color: "var(--2, #AA1A5F)",
            fontFamily: "Poppins",
            fontSize: "16px",
            fontStyle: "normal",
            fontWeight: "600",
            lineHeight: "24px",
          }}
        >
          {loading ? (
            <Spin className="me-2" size="small" spinning={loading} />
          ) : (
            `Total: ${pagination.total || 0} visits`
          )}
        {columnsBar && <span className="ms-auto">{columnsBar}</span>}
        </div>
        <div>
          <Table
            components={tableComponents}
            rowSelection={formattedData.length > 0 ? rowSelection : ""}
            columns={formattedData?.length > 0 ? visibleColumns : []}
            dataSource={formattedData}
            pagination={{
              current: pagination.pageNumber,
              pageSize: pagination.pageSize,
              total: pagination.total,
              onChange: onPageChange,
            }}
            loading={loading}
            // Sideways scroll, so resizing a column can never push the ones
            // after it off the edge with no way to reach them.
            scroll={{ x: "max-content" }}
          />
        </div>
        <Preview
          onClose={handleTogglePreviewModal}
          visible={showPreviewModal}
          siteVisitCardId={selectedSiteVisit}
        />
        {/* <Edit
          visible={showEditModal}
          onCancel={() => setShowEditModal(false)}
          onOk={() => setShowEditModal(false)}
          siteVisitCardId={selectedSiteVisit}
          setMessage={setMessage}
        /> */}
      </div>
      <MessagePopUp
        trigger={message.trigger}
        type={message.type}
        icon={message.icon}
        messageTitle={message.title}
        messageText={message.text}
      />
      <ExportTable visible={isModalVisible} onCancel={handleModalCancel} />
      <ExportSelectedTable
        visible={isSelectedModalVisible}
        onCancel={handleSelectedModalCancel}
        selectedSiteVisitIds={selectedSiteVisitIds}
      />
    </>
  );
}

export default ReportingList;
